export default "__VITE_ASSET__BRCEO2_h__"